<template>
  <ul class="paper-Edit-question">
    <li v-for="(row, i) in exercise.question" :key="row.index">
      <div class="paperEdit-main-bd-question-wrap">
        <div class="paperEdit-main-bd-question">
          <div class="paperEdit-main-bd-question-titleSort">
            {{ row.question_sort }}.&nbsp;<span v-if="row.score != 0">({{ row.score }}分)</span>
          </div>
          <div class="paperEdit-main-bd-question-title" v-html="row.title"></div>
          <div class="paperEdit-main-bd-question-option" v-if="row.options && row.options.length > 0">
            <div v-for="(opt, order) in row.options" :key="order">
              <div v-for="(value, key) in opt" :key="key" :style="{ width: row.w_arr ? row.w_arr[order].width + 'px' : '', paddingLeft: exercise.type_id == 7 && row.w_arr && row.w_arr[order].row == 2 && key == 'C' ? '60px' : '' }">
                <span v-if="exercise.type_id == 7 && key == 'A'">({{ order + 1 }})</span>
                <span :class="exercise.type_id == 7 && key == 'A' ? 'spacer' : ''" :style="{ left: exercise.type_id == 7 && row.w_arr && row.w_arr[order].row == 2 && key == 'C' ? '40px' : '' }">{{ key }}.</span>
                <span v-html="value"></span>
              </div>
            </div>
          </div>
          <div class="audio-wrap" v-if="row.file">
            <audio controls>
              <source :src="row.file" />
            </audio>
          </div>
          <!-- 子题 -->
          <ol class="paperEdit-main-bd-subquestion" v-if="row.sub_questions && row.sub_questions.length > 0">
            <li v-for="subQuestion in row.sub_questions" :key="subQuestion.id">
              <span>({{ subQuestion.question_sort }})</span>
              <div class="paperEdit-main-bd-subquestion-title" v-html="subQuestion.title"></div>
              <!-- 子题选项 -->
              <div class="paperEdit-main-bd-subquestion-options" v-for="(subOption, order) in subQuestion.options" :key="order">
                <div v-for="(value, key) in subOption" :key="key" :style="{ width: subQuestion.sub_width && subQuestion.sub_width.width + 'px' }">
                  <span>{{ key }}.</span>
                  <span v-html="value"></span>
                </div>
              </div>
            </li>
          </ol>
        </div>
        <div class="paperEdit-main-bd-handle">
          <a href="javascript:;" @click="removeExercise(row.question_id)"> <i class="el-icon-delete"></i>删除 </a>
          <a :href="row.question_link" target="_blank"> <i class="iconfont icon-xiangqing"></i>查看解析 </a>
          <a href="javascript:;" @click="toggleCollect(row)"> <i class="iconfont" :class="row.collect == 1 ? 'icon-shoucang0' : 'icon-favourite'"></i>收藏 </a>
          <a href="javascript:;" @click="showChangeDialog(row.question_id)"> <i class="iconfont icon-qiehuan"></i>换题 </a>
          <a href="javascript:;" @click="sortUpDown(exercise.type_id, i, 'up')" v-if="i != 0"> <i class="iconfont icon-shangyi"></i>上移 </a>
          <a href="javascript:;" @click="sortUpDown(exercise.type_id, i, 'down')" v-if="i != exercise.question.length - 1"> <i class="iconfont icon-xiayi"></i>下移 </a>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
var that
import * as util from '../utils/util.js'
import { questionCollect, removePaperExercise } from '@/api/manual.js'
export default {
  name: 'paperEditQuestion',
  props: ['exercise', 'questionListData'],
  data() {
    return {}
  },
  created() {
    that = this
  },
  methods: {
    // 删除
    removeExercise(id) {
      that.$emit('remove', id)
    },
    // 收藏、取消收藏
    async toggleCollect(row) {
      let data = {
        id: row.question_id,
      }
      let res = await questionCollect(data)
      if (res.code == 200) {
        let flag = ''
        if (row.collect == 0) {
          util.showTips('收藏成功')
          flag = 1
        } else {
          util.showTips('取消收藏')
          flag = 0
        }
        that.questionListData.forEach(item => {
          item.question.forEach(item1 => {
            if (item1.question_id == row.question_id) {
              that.$set(item1, 'collect', flag)
            }
          })
        })
      }
    },
    // 换题
    showChangeDialog(id) {
      that.$emit('changeQuestion', id)
    },
    // 排序
    sortUpDown(typeId, i, type) {
      that.questionListData.forEach(item => {
        if (item.type_id == typeId) {
          item.question.forEach((item1, index) => {
            if (i == index) {
              let curItem = '',
                curSort = ''
              curItem = item.question[i] // 当前条
              curSort = curItem.sort // 当前序号
              if (type == 'up') {
                let preItem = '',
                  preSort = ''
                preItem = item.question[i - 1] // 上一条
                preSort = preItem.sort // 上一条的序号
                that.$set(curItem, 'sort', preSort)
                that.$set(preItem, 'sort', curSort)
                that.$set(item.question, i, preItem)
                that.$set(item.question, i - 1, curItem)
              } else {
                let nextItem = '',
                  nextSort = ''
                nextItem = item.question[i + 1] // 下一条
                nextSort = nextItem.sort // 下一条的序号
                that.$set(curItem, 'sort', nextSort)
                that.$set(nextItem, 'sort', curSort)
                that.$set(item.question, i, nextItem)
                that.$set(item.question, i + 1, curItem)
              }
            }
          })
        }
      })
      that.$emit('triggerSavePaper')
    },
  },
}
</script>
<style lang="scss">
.paper-Edit-question {
  .audio-wrap {
    margin-bottom: 10px;
    audio {
      outline: none;
    }
  }
  li {
    .paperEdit-main-bd-question-wrap {
      position: relative;
      zoom: 1;
      border: 1px solid transparent;

      &:hover {
        border-color: #2b99ff;

        .paperEdit-main-bd-handle {
          display: block;
        }
      }

      .paperEdit-main-bd-question {
        width: 100%;
        box-sizing: border-box;
        padding: 10px 10px 0;
        overflow: hidden;

        .paperEdit-main-bd-question-titleSort {
          float: left;
          line-height: 24px;
          color: #333;
          font-size: 14px;
        }

        .paperEdit-main-bd-question-title {
          line-height: 24px;
          margin-bottom: 5px;
          color: #333;
          font-size: 14px;
          overflow: hidden;
        }

        .paperEdit-main-bd-question-option {
          zoom: 1;
          margin-bottom: 10px;
          & > div {
            overflow: hidden;
            & > div {
              position: relative;
              vertical-align: top;
              padding: 0 20px;
              float: left;
              box-sizing: border-box;
              width: 100%;
              line-height: 24px;
              margin-right: 0px;
              font-size: 14px;
              color: #333;
              zoom: 1;
              line-height: 26px;
              & > span {
                display: inline-block;
                &:nth-child(1) {
                  position: absolute;
                  top: 0;
                  left: 0;
                }
                &.spacer + span {
                  vertical-align: middle;
                  white-space: nowrap;
                }
              }
            }
          }
        }
        .paperEdit-main-bd-subquestion {
          color: #333;
          font-size: 14px;
          line-height: 20px;
          margin: 10px 0;
          & > li {
            margin-bottom: 10px;
            overflow: hidden;
            .paperEdit-main-bd-subquestion-title {
              margin-bottom: 5px;
            }
            & > span {
              float: left;
              padding-right: 7px;
            }
            & > .paperEdit-main-bd-subquestion-options {
              overflow: hidden;
              & > div {
                position: relative;
                line-height: 30px;
                box-sizing: border-box;
                float: left;
                vertical-align: top;
                font-size: 14px;
                line-height: 26px;
                padding: 0 20px;
                & > span:nth-child(1) {
                  position: absolute;
                  top: 0;
                  left: 0;
                }
              }
            }
          }
        }
      }

      .paperEdit-main-bd-handle {
        display: none;
        position: absolute;
        top: -31px;
        right: -1px;
        overflow: hidden;
        border-left: 1px solid #2b99ff;

        & > a {
          float: left;
          display: block;
          padding: 0 10px;
          min-width: 60px;
          height: 29px;
          line-height: 29px;
          color: #2b99ff;
          background: #fff;
          font-size: 12px;
          text-align: center;
          border: 1px solid #2b99ff;
          border-left: 0;

          &:hover {
            background: #2b99ff;
            color: #fff;
          }

          & > i {
            display: inline-block;
            font-size: 14px;
            vertical-align: middle;
            margin: -2px 4px 0 0;
          }
        }
      }
    }
  }
}
</style>
